/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_refresh_control__label = /** @type {(inputs: {}) => string} */ () => {
	return `Seite neu laden`
};

const en_refresh_control__label = /** @type {(inputs: {}) => string} */ () => {
	return `Refresh`
};

const es_refresh_control__label = /** @type {(inputs: {}) => string} */ () => {
	return `Actualizar`
};

const fr_refresh_control__label = /** @type {(inputs: {}) => string} */ () => {
	return `Actualiser`
};

const it_refresh_control__label = /** @type {(inputs: {}) => string} */ () => {
	return `Aggiorna`
};

const nl_refresh_control__label = /** @type {(inputs: {}) => string} */ () => {
	return `Vernieuwen`
};

const pt_refresh_control__label = /** @type {(inputs: {}) => string} */ () => {
	return `Atualizar`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const refresh_control__label = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.refresh_control__label(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("refresh_control__label", locale)
	if (locale === "de") return de_refresh_control__label(inputs)
	if (locale === "en") return en_refresh_control__label(inputs)
	if (locale === "es") return es_refresh_control__label(inputs)
	if (locale === "fr") return fr_refresh_control__label(inputs)
	if (locale === "it") return it_refresh_control__label(inputs)
	if (locale === "nl") return nl_refresh_control__label(inputs)
	return pt_refresh_control__label(inputs)
};